module.exports = __webpack_public_path__ + "images/emoji/small_orange_diamond.504736d39c9e2fa9cd7b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/small_orange_diamond.png
// module id = plyR
// module chunks = 13